module.exports = __webpack_public_path__ + "img/Weapon_283.664fce6a.png";